module.exports = __webpack_public_path__ + "static/media/article4.b6490e00.jpeg";